var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.panel ? 'cp-bar cp-bar--alpha' : 'color-alpha',on:{"mousedown":function($event){$event.preventDefault();$event.stopPropagation();return _vm.selectAlpha.apply(null, arguments)}}},[_c('canvas',{ref:"canvasAlpha"}),_c('div',{class:_vm.panel ? 'cp-bar__thumb' : 'slide',style:(_vm.slideAlphaStyle)})])
}
var staticRenderFns = []

export { render, staticRenderFns }